module.exports = __webpack_public_path__ + "img/6_2.5209e7b2.png";